export enum StatusFilaIntegracao {
  NaFila = 0,
  EmExecucao = 1,
  FalhaNaComunicacao = 2,
  IntegradoCriticaNoProvedor = 3,
  IntegradoAguardandoRespostaDoProvedor = 4,
  IntegradoMovimentacaoAceita = 5,
  IntegradoMovimentacaoRecusada = 6,
  EnvioProgramado = 7,
  EnvioCancelado = 9,
}
